/**
 * @Description This is FasatMasterInformation container page
 * @FileName fasatMasterInformation.js
 * @Author SAMAPTI TALUKDAR-talusam
 * @CreatedOn 27 January, 2021 11:15:07
 * @IssueID CDTFASATMOD-502
 */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import '../../../../index.scss';
import './fasatMasterInformation.scss';
import FasatLabel from '../fasatLabel/fasatLabel';
import FasatH2 from '../fasatH2/fasatH2';
import { getAction } from '../../../../stateManagement/reduxUtil';
import { codesAndHierarchyActionTypes } from '../../../modules/codesAndHierarchyExternal/redux';
import FasatLinkButton from '../fasatLinkButton/fasatLinkButton';

function FasatMasterInformation({ information, infoTitle, showInfoTitle, chDetails, orgLevel }) {
  const history = useNavigate();
  const dispatch = useDispatch();

  const handleLinkClick = useCallback((level, movOrgCd) => {
    dispatch(getAction(
      codesAndHierarchyActionTypes.GET_CODES_AND_HIER_MOVEMENT_REQUEST,
      { level, movOrgCd },
    ));
    history('/codeAndHierarchy', { state: { status: 'grid' } });
  }, [dispatch]);

  const createClickHandler = useCallback((info) => () => handleLinkClick(orgLevel, info.value), [handleLinkClick, orgLevel]);
  return (
    <div className="masterInfoSection" data-testid="FasatMasterInformationComponent">
      {showInfoTitle && <FasatH2>{infoTitle}</FasatH2>}
      { information.map((info) => (
        <div className={`infoCell ${chDetails ? 'hideMasterHeader' : ''}`} key={info.key}>
          <FasatLabel>{info.key}</FasatLabel>
          { !info.isCodeAndHierHyperlink && <FasatLabel isContent>{info.value}</FasatLabel>}
          { info.isCodeAndHierHyperlink && (
            <FasatLinkButton
              icon="Chart4"
              class="hyperlink"
              tabIndex="0"
              ariaLabel={info.value}
              onClick={createClickHandler(info)}
            >
              <span className="hyper-link">
                {' '}
                {info.value}
                {' '}
              </span>
            </FasatLinkButton>
          )}
        </div>
      ))}

      {chDetails && (
      <div className="infoCell viewChMasterHeader">
        <FasatLabel>{chDetails.key}</FasatLabel>
        <FasatLabel isContent>{chDetails.value}</FasatLabel>
      </div>
      )}

    </div>
  );
}

FasatMasterInformation.propTypes = {
  information: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  })),
  infoTitle: PropTypes.string,
  showInfoTitle: PropTypes.bool,
  chDetails: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  })),
  orgLevel: PropTypes.string,
};

FasatMasterInformation.defaultProps = {
  information: [],
  infoTitle: '',
  showInfoTitle: true,
  chDetails: null,
  orgLevel: null,
};

export default FasatMasterInformation;
